module.exports = {
  app: {
    allapp: "所有应用",
    ok: "确定",
    entrust: "增加委托",
    BackTolist: "返回授权列表",
    mailbox: "邮箱",
    phone: "手机号",
    modify: "修改",
    saveok: "保存分类成功,是否回到应用列表？",
    deleteok: "是否确认删除？",
    SendCode: "发送验证码",
    SendAgain: "Send again",
    reSendCode: "重新发送",
    applicant: "申请人",
    TaskName: "任务名称",
    ApprovalType: "审批类型",
    state: "状态",
    operation: "操作",
    details: "详情",
    FormFilling: "表单填写",
    cancel: "取消",
    classificationName: "请填写分类名称",
    ClassificationAlreadyExists: "分类已存在",
    categories: "分类不能超过10个",
    PermissionSelection: "权限选择",
    reason: "原因",
    Submit: "提交",
    PleaseSelect: "请选择",
    clickCode: "点击发送验证码",
    notBindPhone: "暂未绑定手机号码，请先去绑定手机!",
  },

  describe: {
    login: "登 录",
    inputPwd: "请输入密码",
    inputUser: "请输入用户名/手机号/邮箱",
    auth: "BNBU身份认证服务",
    auth1: "单点登录",
    // auth2:"温馨提示:请输入账号密码验证登录",
    // tips_01:"重要提示",
    // tips_02:"登录前，请务必验证网页的网址并确保它已启动",
    // tips_03:"在访问服务后注销并关闭所有浏览器窗口",
    required: "必填字段",
    phoneNumber: "请输入手机号码",
    phoneVerificationCode: "请输入手机验证码",
    GraphicVerificationCode: "请输入图形验证码",
    AppManage: "应用管理",
    SwitchTo: "切换至",
    ioaQuickLogon: "ioa快速登录",
    AccountPasswordLogin: "账号密码登录",
    EnterpriseWechat: "企业微信2.4",
    Use: "使用",
    AboveVersionScanQRcodeLogin: "以上版本扫描二维码登录",
    Or: "或",
    IncorrectFormatOfMobilePhoneNumber: "手机号码格式不正确！",
    PleaseInputTheGraphicVerificationCode: "请输入图形验证码！",
    ItHasToBeANumber: "必须是数字",
    PleaseEnterAValidIDNumber: "请输入有效身份证号码",
    EmailOrInChineseEnglishNumbersUnderscoresAndHorizontalLines:
      "邮箱或者以中文、英文、数字、下划线以及横线组成！",
    TheTwoPasswordsAreInconsistent: "两次密码输入不一致",
    ItHasToBe: "必须是",
    digit: "位",
    IsAnUnsupportedFormValidationType: "是不支持的表单类型",
    RegularVerificationFailed: "正则验证不通过",
    InputCannotExceed: "输入不能超过",
    character: "个字符",
    InputCannotBeLessThan: "输入不能少于",
    PleaseCheck: "请检查",
    LongTermValidity: "长期有效",
    TakeEffectAfter: "后生效",
    Invalid: "已失效",
    PostFailure: "后失效",
    Disabled: "被禁用",
    NoCertification: "无认证",
    LastCertification: "上次认证",
    Password: "口令",
    QRCode: "二维码",
    fingerprint: "指纹",
    DynamicCode: "动态码",
    ShortMessage: "短信",
    Mail: "邮件",
    AbnormalError: "异常错误",
    VerificationCodeIsRequired: "验证码必填",
  },

  error: {
    phoneNumber: "手机号码有误",
  },

  password: {
    forgetpwd: "忘记密码？",
  },

  login: {
    other: "返回其他方式登录",
  },

  menu: {
    ApplicationList: "应用列表",
    IDHousekeeper: "ID管家",
    jurisdiction: "权限申请",
    Jission: "我的任务",
    User: "用户信息",
    password: "修改密码",
    out: "退出登录",
  },

  ID: {
    butler: "绑定ID管家",
    OPEN: "请打开ID管家",
    Scan: "请扫描上方二维码绑定",
    Download: "ID管家下载",
  },

  ChangePassword: {
    password: "修改密码",
    Original: "原密码",
    Original1: "请输入原密码",
    NewPassword: "新密码",
    NewPassword1: "请输入新密码",
    confirm: "确认修改密码",
    Reconfirm: "确认新密码",
    Reconfirm1: "请再次输入新密码",
    reset: "重置密码",
    reset1: "确认重置密码",
    Forget: "忘记密码-短信重置密码",
    phone: "手机号",
    ErrorMsg: "手机号码有误！",
    phone1: "请输入您的手机号码",
    Dynamic: "动态码",
    Dynamic1: "请输入动态码！",
    ResetValidation: "重置验证",
    ReturnToLogin: "返回登录",
    return: "返回",
    PasswordRules: "密码规则",
    PasswordRules01: "1) 同时包含大写字母、小写字母和数字",
    PasswordRules02: "2) 密码长度为6-32为字符",
    PasswordRules03: "3) 不包含账号信息与空",
    PasswordRules04:
      "4) 不能是常见密码（容易破解的密码）,密码里不能包含连续字母或数字：1234， 123456， 111，2222， 12345678 等，例如：Password1234 ",
    // returnclose: "关闭页面",
    ChangePwd: "密码修改成功!",
    PasswordResetSucceeded: "密码重置成功",
    SetMobileNumber: "设置手机号",
    VerificationCode: "验证码",
    VerificationCode1: "请输入验证码！",
    MailReset: "邮件重置",
    MailBox: "邮箱",
    MailBox1: "请输入邮箱",
    ReturnToSelectResetMode: "返回选择重置方式",
    Next: "下一步",
    register: "注册",

    pleaseAgreement: "请阅读并同意此协议",
    pleaseAgreement1: "请阅读并勾选下方的声明",
    already: "我已阅读并同意",
    read1: "我已阅读并同意此协议（5/4/3/2/1）",
    read2: "我已阅读并同意此协议（滑到页面底部）",
    read3: "我已阅读并同意此协议",
    userInfoPwd1: "《个人信息隐私收集及使用政策》",
    userInfoPwd2: "《个人信息收集和信息系统授权声明》",
  },

  user: {
    information: "用户信息",
    lastTime: "最后访问时间",
    name: "用户名",
    mail: "邮箱",
    effective: "生效日期",
    attribute: "用户属性",
    Return: "返回应用列表",
  },

  Authorization: {
    apply: "新增申请",
    AuthorityDefinition: "权限定义",
    state: "状态",
    errorMessage: "错误信息",
    operation: "操作",
    cancel: "取消",
  },

  AppManage: {
    add: "添加应用分类",
    addApp: "添加应用",
    sequencing: "应用排序",
    addTo: "添加",
    Del: "删除",
    return: "<返回",
    save: "保存分类",
    name: "请输入应用分类名",
  },

  ApplicationSettings: {
    jurisdiction: "权限：",
    state: "授权状态：",
    available: "可用",
    Disable: "禁用",
    AccountStatus: "账号状态：",
    AccountPeriod: "账号期限",
    AddDelegation: "新增委托",
    DelegationList: "委托列表",
    NumberOfAccounts: "当前账号总数：",
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/utiles/locale/zh_CN.js
// module id = 207
// module chunks = 0